<template>
  <div class="card-list">
    <ul class="card-ul">
      <li class="card-item" v-for="(item, index) in studentListCardData" :key="index" @click="viewStudent">
        <div class="user-info">
          <div class="left-image">
            <div class="photo-image">
              <span class="name">{{item.real_name.slice(0, 2)}}</span>
            </div>
          </div>
          <div class="user-course">
            <p class="user-name">{{item.real_name}}</p>
            <div class="course-detail">
              <span>{{item.data[0].course_sname}}</span>
              <span>{{item.data[0].section_sname}}</span>
              <span>{{item.data[0].topic_sname}}</span>
            </div>
          </div>
        </div>
        <div class="handle-wrap">
          <div class="handle-item first">
            <div>
              <span class="current">{{item.data[0].event | getEventName}}</span>
            </div>
            <div class="bottom-tips">
              <span>{{ $t('studentList.card.829160-0') }}</span>
              <span>15:20</span>
            </div>
          </div>
          <div class="handle-item second">
            <p class="rate">40%</p>
            <p class="bottom-tips">{{ $t('studentList.card.829160-1') }}</p>
          </div>
          <div class="handle-item third">
            <p class="rate">67%</p>
            <p class="bottom-tips">{{ $t('studentList.card.829160-2') }}</p>
          </div>
        </div>
        <div class="current-module">
          <span class="module-name">【{{item.data[0].module_sname}}】</span>
          <span class="knowledge-text">{{item.data[0].tag_sname}}</span>
        </div>
        <ul class="history-ul">
          <li v-for="(item, index) in messageList" v-if="index < 4" :key="'history_' + item ">
            <span class="history-item">{{item.event | getEventName}}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: "card",
    data () {
      return {

      }
    },
    props: {
      studentListCard: {
        type: Array,
      },
      messageList: {
        type: Array,
      },
      current: {
        type: Number
      }
    },
    computed: {
      ...mapGetters([
        'studentListCardData'
      ]),
    },
    methods: {
      viewStudent () {
        this.$router.push({ path: '/supervise/detail', query: { }});
      }
    },
    filters: {
      parseTime(time) {
        if (arguments.length === 0) {
          return null
        }
        const format = '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
          date = time
        } else {
          if (('' + time).length === 10) time = parseInt(time) * 1000
          date = new Date(time)
        }
        const formatObj = {
          y: date.getFullYear(),
          m: date.getMonth() + 1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
          let value = formatObj[key]
          if (key === 'a') return [this.$t('studentList.card.829160-3'), this.$t('studentList.card.829160-4'), this.$t('studentList.card.829160-5'), this.$t('studentList.card.829160-6'), this.$t('studentList.card.829160-7'), this.$t('studentList.card.829160-8'), this.$t('studentList.card.829160-9')][value - 1]
          if (result.length > 0 && value < 10) {
            value = '0' + value
          }
          return value || 0
        })
        return time_str
      },
      parseUserSpentTime(msd) {
        var time = parseFloat(msd) / 1000
        if (time !== null && time !== '') {
          // 当答题用时超过30分钟时，只显示30分钟
          if (time > 30 * 60) {
            time = 30 * 60
          }
          if (time > 60 && time < 60 * 60) {
            time = parseInt(time / 60.0) + this.$t('studentList.card.829160-10') + parseInt((parseFloat(time / 60.0) -
              parseInt(time / 60.0)) * 60) + this.$t('studentList.card.829160-11')
          } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
            time = parseInt(time / 3600.0) + this.$t('studentList.card.829160-12') + parseInt((parseFloat(time / 3600.0) -
              parseInt(time / 3600.0)) * 60) + this.$t('studentList.card.829160-10') +
              parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
                parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + this.$t('studentList.card.829160-11')
          } else {
            if (isNaN(time)) {
              return this.$t('studentList.card.829160-13')
            } else {
              if (time < 0) {
                time = 0
              }
              time = parseInt(time) + this.$t('studentList.card.829160-11')
            }
          }
        }
        return time
      },
      // 卡片事件
      getEventName(val) {
        let eventName = ''
        switch (val) {
          case 'LOGIN':
            eventName = this.$t('studentList.card.829160-14')
            break
          case 'RELOGIN':
            eventName = this.$t('studentList.card.829160-15')
            break
          case 'MODULE_START':
            eventName = this.$t('studentList.card.829160-16')
            break
          case 'GET_QUESTION':
            if (val.hasOwnProperty('question_round')) {
              if (val.question_round == 1) {
                eventName = this.$t('studentList.card.829160-17')
              } else if (val.question_round == 2) {
                eventName = this.$t('studentList.card.829160-18')
              }
            } else {
              eventName = this.$t('studentList.card.829160-19')
            }
            break
          case 'SUBMIT_ANSWER':
            eventName = val.flow_id == 1000 ? '考试结束' : this.$t('studentList.card.829160-20')
            break
          case 'GET_ANALYSIS':
            if (val.hasOwnProperty('question_round')) {
              if (val.question_round == 1) {
                eventName = this.$t('studentList.card.829160-21')
              } else if (val.question_round == 2) {
                eventName = this.$t('studentList.card.829160-22')
              }
            } else {
              eventName = this.$t('studentList.card.829160-23')
            }
            break
          case 'GET_QLIST':
            eventName = this.$t('studentList.card.829160-24')
            break
          case 'GET_REPORT':
            eventName = this.$t('studentList.card.829160-25')
            break
          case 'VIDEO_PLAY':
            eventName = this.$t('studentList.card.829160-26')
            break
          case 'VIDEO_CLOSE':
            eventName = this.$t('studentList.card.829160-27')
            break
          case 'VIDEO_END':
            eventName = this.$t('studentList.card.829160-28')
            break
          case 'VIDEO_PAUSE':
            eventName = this.$t('studentList.card.829160-29')
            break
          case 'VIDEO_DRAG':
            eventName = this.$t('studentList.card.829160-30')
            break
          case 'VIDEO_BACK':
            eventName = this.$t('studentList.card.829160-31')
            break
          case 'VIDEO_SKIP':
            eventName = this.$t('studentList.card.829160-32')
            break
          case 'VIDEO_END_DAZE':
            eventName = this.$t('studentList.card.829160-33')
            break
          case 'VIDEO_PAUSE_DAZE':
            eventName = this.$t('studentList.card.829160-34')
            break
          case 'VIDEO_UNPLAYED_SKIP':
            eventName = this.$t('studentList.card.829160-35')
            break
          case 'NO_ACTION':
            eventName = this.$t('studentList.card.829160-36')
            break
          case 'WARN_VIDEO_UNPLAYED_SKIP':
            eventName = this.$t('studentList.card.829160-37')
            break
          case 'WARN_VIDEO_PLAYED_SKIP':
            eventName = this.$t('studentList.card.829160-38')
            break
          case 'WARN_VIDEO_PAUSE_DAZE':
            eventName = this.$t('studentList.card.829160-34')
            break
          case 'WARN_VIDEO_END_DAZE':
            eventName = this.$t('studentList.card.829160-33')
            break
          case 'WARN_NO_ACTION':
            eventName = this.$t('studentList.card.829160-39')
            break
          case 'ANSWER_HESITATE':
            eventName = this.$t('studentList.card.829160-40')
            break
          case 'WARN_ANSWER_HESITATE':
            eventName = this.$t('studentList.card.829160-40')
            break
          // case 'WARN_MODULE_END':
          //   eventName = '模块完成报警'
          //   break
          case 'WARN_WRONG_ANSWER':
            eventName = this.$t('studentList.card.829160-41')
            break
          case 'MODULE_END':
            eventName = this.$t('studentList.card.829160-42')
            break
          case 'TAG_CODE_END':
            eventName = this.$t('studentList.card.829160-43')
            break
          case 'WARN_ANSWE_TOO_SLOW':
            eventName = this.$t('studentList.card.829160-44')
            break
          case 'WARN_ANSWE_TOO_FAST':
            eventName = this.$t('studentList.card.829160-45')
            break
          default:
            eventName = this.$t('studentList.card.829160-13')
        }
        return eventName
      }
    }
  }
</script>

<style scoped lang="scss">
  .card-list {
    .card-ul {
      overflow: hidden;
      .card-item {
        float: left;
        width: 410px;
        height: 302px;
        margin: 0 20px 29px 0;
        background: rgba(255,255,255,1);
        box-shadow: 0px 6px 12px 0px rgba(68,75,101,0.06);
        border-radius: 8px;
        border: 1px solid rgba(225,237,255,1);
        box-sizing: border-box;
        cursor: pointer;
        .user-info {
          display: flex;
          justify-content: start;
          margin: 25px 0 0 20px;
          .left-image {
            .photo-image {
              width: 36px;
              height: 36px;
              background: #90DF89;
              border-radius: 100px;
              display: flex;
              align-items: center;
              text-align: center;
              .name {
                width: 36px;
                height: 15px;
                font-size: 12px;
                font-weight: 500;
                color: #FFFFFF;
              }
            }
          }
          .user-course {
            margin-left: 13px;
            .user-name {
              height: 28px;
              margin-top: 3px;
              font-size: 20px;
              font-weight: 600;
              color: #444B65;
              line-height: 28px;
            }
            .course-detail {
              width: 300px;
              margin-top: 4px;
              font-size: 12px;
              color: #858A9B;
              line-height: 19px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
          }
        }
        .handle-wrap {
          margin-top: 30px;
          margin-left: 17px;
          display: flex;
          .handle-item {
            .current {
              font-size: 18px;
              color: #444B65;
            }
            &.first {
              width: 151px;
            }
            &.second {
              width: 77px;
              text-align: center;
              border-right: 1px dotted #E4EFF6;
              .rate {
                font-size: 18px;
                color: #FF4757;
              }
            }
            &.third {
              margin-left: 14px;
              text-align: center;
              .rate {
                font-size: 18px;
                color: #207CFF;
              }
            }
            .bottom-tips {
              font-size: 12px;
              color: #858A9B;
            }
          }
        }
        .current-module {
          height: 42px;
          margin: 29px 19px 37px 19px;
          display: flex;
          align-items: center;
          background: #EFF6FF;
          background: rgba(239, 246, 255, 0.68);
          border: 1px solid #EDF5FF;
          border-radius: 4px;
          .module-name {
            font-size: 14px;
            color: #444B65;
            font-weight: 600;
          }
          .knowledge-text {
            font-size: 14px;
            color: #858A9B;
            line-height: 20px;
          }
        }
        .history-ul {
          padding: 0 18px;
        }
        &:hover {
          border: 1px solid #207CFF;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/studentList/card.vue